import { useMemo, useState } from 'react';

import portfolio from '../../data';
import useInView from '../../hooks/useInView';
import ProjectCard from '../ProjectCard';
import Reveal from '../ui/Reveal';
import SectionHeading from '../ui/SectionHeading';

import '../../styles/Works/Works.scss';

const ALL = 'All';

/** Grid whose cards stagger in once it scrolls into view (re-mounted on filter change). */
function ProjectGrid({ children }) {
  const [ref, inView] = useInView({ threshold: 0.05 });
  return (
    <div ref={ref} className={`works__grid${inView ? ' is-in' : ''}`}>
      {children}
    </div>
  );
}

const Works = () => {
  const cards = portfolio.portfolio.projectCard.cards;
  const [filter, setFilter] = useState(ALL);

  const filters = useMemo(() => {
    const counts = new Map();
    cards.forEach((c) => (c.categories || []).forEach((cat) => counts.set(cat, (counts.get(cat) || 0) + 1)));
    return [[ALL, cards.length], ...counts.entries()];
  }, [cards]);

  const visible = filter === ALL ? cards : cards.filter((c) => (c.categories || []).includes(filter));

  return (
    <section className="section works" id="work" aria-labelledby="work-title">
      <div className="container">
        <SectionHeading
          index="04"
          eyebrow="Selected work"
          id="work-title"
          title="Things I've"
          accent="built & shipped."
          description="Aviation systems running at airport gates, commerce platforms, and logistics products serving thousands of businesses."
        />

        <Reveal className="works__filters" role="group" aria-label="Filter projects by category">
          {filters.map(([name, count]) => (
            <button
              key={name}
              type="button"
              className={`works__filter${filter === name ? ' is-active' : ''}`}
              aria-pressed={filter === name}
              onClick={() => setFilter(name)}
            >
              {name}
              <span className="works__filter-count">{count}</span>
            </button>
          ))}
        </Reveal>

        <p className="sr-only" aria-live="polite">
          Showing {visible.length} {visible.length === 1 ? 'project' : 'projects'}
        </p>

        <ProjectGrid key={filter}>
          {visible.map((content, index) => (
            <ProjectCard
              key={content.heading}
              cardContent={content}
              cardIndex={cards.indexOf(content)}
              order={index}
            />
          ))}
        </ProjectGrid>
      </div>
    </section>
  );
};

export default Works;
